import { TablePaginationConfig } from 'antd';
import i18next from 'i18next';

import { DEFAULT_PAGE_SIZE } from '../commons/constants';

export const getPaginationConfig = (props: {
  pagination: { number: number; totalElements: number; size: number };
  onChange: (page: number, pageSize: number) => void;
  onShowSizeChange?: (current: number, size: number) => void;
}): TablePaginationConfig => {
  const { onChange, pagination, onShowSizeChange } = props;
  // const position: any[] = ['bottomRight'];

  // if (pagination.totalElements > DEFAULT_PAGE_SIZE) {
  //   position.push('topRight');
  // }

  return {
    position: ['topRight'],
    showSizeChanger: true,
    onChange: onChange,
    showTotal: () => i18next.t('common.pagination-total', { total: pagination.totalElements }),
    onShowSizeChange: onShowSizeChange,
    defaultPageSize: DEFAULT_PAGE_SIZE,
    defaultCurrent: 1,
    pageSize: pagination.size,
    current: pagination.number + 1,
    total: pagination.totalElements,
  };
};
